export enum AnalyticShowDataRangeEnum {
  WEEK,
  MONTH,
  QUARTER,
  YEAR,
}
